var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reset-pw"},[_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t('resetPassword.hint')))]),_c('ResetPasswordForm',{attrs:{"email":_vm.email,"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }